export default () => ({
  schedules: [],
  currentSchedule: {},
})
